"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _supersizeMyEdit = require("../constants/supersizeMyEdit");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var sortByVersionNumber = function sortByVersionNumber(outputVersions) {
  return outputVersions.sort(function (a, b) {
    return a.versionNumber - b.versionNumber;
  });
};
var mergeCommonAddon = function mergeCommonAddon(addonType, addon) {
  return _defineProperty({}, addonType, addon);
};
var mergeComplexAddon = function mergeComplexAddon(addonType, addons, prevVersionsAddons) {
  var prevAddons = prevVersionsAddons[addonType] || [];
  if (!Array.isArray(addons)) {
    return addons;
  }
  var newAddons = addons.reduce(function (acc, addon) {
    var newAcc = acc.filter(function (prevStrCaption) {
      return prevStrCaption.value !== addon.value;
    });
    return [].concat(_toConsumableArray(newAcc), [addon]);
  }, _toConsumableArray(prevAddons));
  return _defineProperty({}, addonType, newAddons);
};
var getAppliedRushEdit = function getAppliedRushEdit(addon) {
  if (addon.status !== 'APPROVED') {
    return {};
  }
  return {
    RUSH_EDIT: addon
  };
};
var getRequestedRushEdit = function getRequestedRushEdit(addon) {
  if (addon.status !== 'PENDING') {
    return {};
  }
  return {
    RUSH_EDIT: addon
  };
};
var getBriefRushEdit = function getBriefRushEdit(addon) {
  if (addon.status === 'REJECTED') {
    return {};
  }
  return {
    RUSH_EDIT: addon
  };
};
var mergeRushEdit = function mergeRushEdit(addon, addonsSelector, isBrief) {
  var isAppliedVisible = addonsSelector === 'appliedAddons';
  if (isBrief) {
    return getBriefRushEdit(addon);
  }
  if (isAppliedVisible) {
    return getAppliedRushEdit(addon);
  }
  return getRequestedRushEdit(addon);
};
var mergeBurnInCaptions = function mergeBurnInCaptions(addon, prevVersionsAddons) {
  return mergeComplexAddon('BURN_IN_CAPTIONS', [addon], prevVersionsAddons);
};
var mergeSrtCaptions = function mergeSrtCaptions(addon, prevVersionsAddons) {
  return mergeComplexAddon('SRT_CAPTIONS', addon, prevVersionsAddons);
};
var mergeSuperSizeMyEditMultiple = function mergeSuperSizeMyEditMultiple(addon, prevAddons) {
  if (!addon.addonId) {
    var _prevAddonsWithoutNewAddon = prevAddons.filter(function (prevAddon) {
      var isPrevAddonWithoutId = addon.value === prevAddon.value && !prevAddon.addonId;
      return !isPrevAddonWithoutId;
    });
    return [].concat(_toConsumableArray(_prevAddonsWithoutNewAddon), [addon]);
  }
  var prevAddonsWithoutNewAddon = prevAddons.filter(function (prevAddon) {
    return prevAddon.addonId !== addon.addonId;
  });
  return [].concat(_toConsumableArray(prevAddonsWithoutNewAddon), [addon]);
};
var mergeSuperSizeMyEditCommon = function mergeSuperSizeMyEditCommon(addon, prevAddons) {
  var prevAddonsWithoutNewAddon = prevAddons.filter(function (prevAddon) {
    return prevAddon.value !== addon.value;
  });
  return [].concat(_toConsumableArray(prevAddonsWithoutNewAddon), [addon]);
};
var mergeSupersizeMyEdit = function mergeSupersizeMyEdit(addons, prevVersionsAddons) {
  var prevAddons = prevVersionsAddons.SUPERSIZE_MY_EDIT || [];
  var newAddons = addons.reduce(function (acc, addon) {
    if (addon.value && _supersizeMyEdit.addonsWithMultipleValues.includes(addon.value)) {
      return mergeSuperSizeMyEditMultiple(addon, acc);
    }
    return mergeSuperSizeMyEditCommon(addon, acc);
  }, _toConsumableArray(prevAddons));
  return {
    SUPERSIZE_MY_EDIT: newAddons
  };
};
var mergeAddon = function mergeAddon(addonType, addon, prevVersionsAddons, addonsSelector, isBrief) {
  if (!addon) {
    return {};
  }
  switch (addonType) {
    case 'RUSH_EDIT':
      {
        var commonAddon = addon;
        return mergeRushEdit(commonAddon, addonsSelector, isBrief);
      }
    case 'SUPERSIZE_MY_EDIT':
      {
        var complexAddon = addon;
        return mergeSupersizeMyEdit(complexAddon, prevVersionsAddons);
      }
    case 'SRT_CAPTIONS':
      {
        var _complexAddon = addon;
        return mergeSrtCaptions(_complexAddon, prevVersionsAddons);
      }
    case 'BURN_IN_CAPTIONS':
      {
        var _commonAddon = addon;
        return mergeBurnInCaptions(_commonAddon, prevVersionsAddons);
      }
    default:
      {
        var _commonAddon2 = addon;
        return mergeCommonAddon(addonType, _commonAddon2);
      }
  }
};
var mergeAddons = function mergeAddons(prevVersionsAddons, currVersionAddon, addonsSelector, isBrief) {
  var addonsEntries = currVersionAddon ? Object.entries(currVersionAddon) : [];
  var mergedAddons = addonsEntries.reduce(function (accAddons, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      addonType = _ref4[0],
      addon = _ref4[1];
    return _objectSpread(_objectSpread({}, accAddons), mergeAddon(addonType, addon, prevVersionsAddons, addonsSelector, isBrief));
  }, {});
  return mergedAddons;
};
var getOutputAddonsReport = function getOutputAddonsReport(output) {
  var addonsSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appliedAddons';
  var isBrief = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var sortedVersions = sortByVersionNumber(output.versions);
  return sortedVersions.reduce(function (acc, version) {
    return _objectSpread(_objectSpread({}, acc), mergeAddons(acc, version[addonsSelector], addonsSelector, isBrief));
  }, {});
};
var _default = getOutputAddonsReport;
exports["default"] = _default;